import React from 'react';
import { connect } from 'react-redux';

import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import ActivityList from 'apps/auth/components/ga/activity/ActivityList';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { resolveArguments, toUpperCase } from 'apps/auth/helpers/utils';

const AccountActivityListPage = (props) => {
    return (
        <CommonPage backUrl={`${AUTH_GA_POCKET}${props.pocketId}`}>
            <ActivityList
                pocketId={props.pocketId}
                fetchUrl={`/auth/ga/pocket/${props.pocketId}/activity.next`}
                historyTitle={resolveArguments(props.pocketActivityTitle, toUpperCase(props.currencyCode))}
                showStatement={!props.isLibre}
            />
        </CommonPage>
    );
};

const mapStateToProps = (state) => {
    return {
        pocketId: state.extra.pocket?.id,
        currencyCode: state.extra.pocket?.pocketCurrency?.code,
        isLibre: state.extra.isLibre,
        pocketActivityTitle: state.messages.pageMessages.pocketActivityTitle,
    };
};

export default connect(mapStateToProps)(BasePage(AccountActivityListPage));
